module.exports = __webpack_public_path__ + "img/tpc-2.65587a85.webp";